import { useStore } from 'zustand'

import { useSitePromotionPopupsStore } from '../../_core/hook'

import { useIsAppQuery } from '@/hooks/useIsAppQuery'
import { useSideBarData } from '@/pages/tad.ai/_layout/SideBar/data'


import { useRouter } from '@/hooks/routes';
import { useMemo, useEffect } from 'react';
export function useConsistentCharacterModalInit() {
  const store = useSitePromotionPopupsStore()
  const init = useStore(store, (s) => s.init)
  const popupPaths = useSideBarData()
  const router = useRouter()
  const popupPathRegs = useMemo(() => {
    return [/^\/tad.ai$/].concat(
      popupPaths.map((path) => new RegExp(`^/tad.ai${path.href}$`)),
    )
  }, [])
  const isApp = useIsAppQuery()
  useEffect(() => {
    const allowPaths = popupPathRegs.some((reg) => reg.test(router.pathname))
    const open = !isApp && allowPaths
    init({ key: 'consistentCharacterModalV3', open })
  }, [init, isApp, router.pathname])
}
